import { useRef, useEffect } from 'react';

export function useAnimationFrame(callback) {
    const requestRef = useRef();
    const previousTimeRef = useRef();

    useEffect(() => {
        function animate(time) {
            if (previousTimeRef.current !== undefined) {
                const deltaTime = time - previousTimeRef.current;
                callback(time, deltaTime);
            }
            previousTimeRef.current = time;
            requestRef.current = requestAnimationFrame(animate);
        }
        requestRef.current = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(requestRef.current);
    }, [callback]);
}
